(() => {
  if (customElements.get('sp-promo-price-test')) return;
  customElements.define('sp-promo-price-test', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      try { this.config = JSON.parse(this.querySelector('[data-promo-config]').textContent); }
      catch { return; }
      if (!this.root) return;
      this.ready = true;
      this.abort = new AbortController();
      this.update = this.update.bind(this);
      this.root.addEventListener('change', this.update, {signal:this.abort.signal});
      this.root.addEventListener('input', this.update, {signal:this.abort.signal});
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.root, {childList:true, subtree:true, attributes:true, attributeFilter:['value','disabled']});
      this.timer = setInterval(this.update, 1000);
      this.querySelector('[data-promo-copy]').addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(this.config.settings.code); this.setText('[data-promo-note]', 'Code copied. Enter it at checkout; eligibility is confirmed there.'); }
        catch { this.setText('[data-promo-note]', 'Copy this code: ' + this.config.settings.code); }
      }, {signal:this.abort.signal});
      this.update();
    }
    disconnectedCallback() {
      this.ready = false;
      this.observer?.disconnect(); this.abort?.abort(); clearInterval(this.timer);
      this.root?.removeAttribute('data-promo-hide-original');
    }
    setText(selector, value) {
      const e = this.querySelector(selector);
      if (e && e.textContent !== value) e.textContent = value;
    }
    update() {
      const {settings:s, variants, currency, supported} = this.config;
      const id = this.root.querySelector('product-form input[name="id"]')?.value || this.config.initial;
      const variant = variants.find(v => String(v.id) === String(id));
      if (!variant) { this.root.removeAttribute('data-promo-hide-original'); this.hidden = true; return; }
      this.hidden = false;
      const quantity = Number(this.root.querySelector('.product-form__quantity input[name="quantity"]')?.value || 1);
      const amount = Number(s.amount);
      const date = value => !value || (/T.*(?:Z|[+-]\d\d:\d\d)$/.test(value) && Number.isFinite(Date.parse(value)));
      const now = Date.now();
      // Percentage offers use the current presentment price; no exchange conversion is needed.
      const currencyMatches = s.discount_type === 'percent' || currency === String(s.currency).trim().toUpperCase();
      const valid = supported && currencyMatches && Number.isFinite(amount) && amount > 0 &&
        (s.discount_type !== 'percent' || amount <= 100) && date(s.starts) && date(s.ends) &&
        (!s.starts || now >= Date.parse(s.starts)) && (!s.ends || now < Date.parse(s.ends));
      const qualifies = valid && quantity >= s.min_quantity && variant.available && !this.root.querySelector('input[name="selling_plan"]:checked');
      const discount = s.discount_type === 'percent' ? Math.round(variant.price * amount / 100) : Math.round(amount * 100);
      const reduced = Math.max(0, variant.price - discount);
      const isCode = s.mode === 'code';
      const showOffer = qualifies && (!isCode || Boolean(s.code?.trim()));
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100);
      this.root.toggleAttribute('data-promo-hide-original', Boolean(s.hide_original));
      this.querySelector('[data-promo-was]').hidden = !showOffer;
      this.toggleAttribute('data-offer', Boolean(showOffer));
      this.setText('[data-promo-was]', money(variant.price) + ' ' + currency);
      this.setText('[data-promo-now]', money(showOffer ? reduced : variant.price) + ' ' + currency);
      this.querySelector('[data-promo-label]').hidden = !showOffer;
      this.setText('[data-promo-label]', isCode ? 'With code ' + s.code : 'ON SALE');
      this.querySelector('[data-promo-copy]').hidden = !(showOffer && isCode);
      const message = !valid ? 'No active supported preview rule. Regular price shown.' : quantity < s.min_quantity ? `Buy at least ${s.min_quantity} of this product to qualify. Current quantity: ${quantity}.` : isCode ? 'Code is not applied. Button shows regular unit price until checkout confirms the code.' : 'Estimated automatic offer per item. Actual discount is confirmed in cart/checkout.';
      this.setText('[data-promo-note]', message);
      this.querySelector('[data-promo-note]').hidden = !(showOffer && isCode);
      // Never modify variant IDs, form payloads, product prices, or cart totals.
      const target = this.root.querySelector('[data-pdp-submit-price]');
      const buttonPrice = showOffer && !isCode ? money(reduced) : variant.money;
      if (target && target.textContent !== buttonPrice) target.textContent = buttonPrice;
    }
  });
})();
